import React, { useEffect, useState } from "react";
import {collection, getDocs } from "firebase/firestore";
import { db } from "../../services/firebase";
import { ReactComponent as FileIcon } from '../../assets/icons/FileIcon.svg';
import LoadingSpinner from "../LoadingSpinner";
import EmptyState from "../EmptyState";
import { useNavigate } from "react-router-dom";

const Inventario = () => {
const [inventario, setInventario] = useState([]);
const [recientes, setRecientes] = useState([]);
const [loading, setLoading] = useState(true);
const navigate = useNavigate();

  const handleRowClick = (id) => {
    navigate(`/inventario/${id}`);
  };

useEffect(() => {
const fetchData = async () => {
try {
const inventarioSnap = await getDocs(collection(db, "inventario"));
const inventarioData = inventarioSnap.docs.map((doc) => ({
id: doc.id,
...doc.data(),
}));
const inventarioOrdenado = [...inventarioData].sort((a, b) => {
const fa = a.fecha?.toDate?.() || new Date(a.fecha || 0);
const fb = b.fecha?.toDate?.() || new Date(b.fecha || 0);
return fb - fa;
});
setInventario(inventarioOrdenado);
setRecientes(inventarioOrdenado.slice(0, 4));
} catch (error) {
console.error("Error al traer datos de inventario:", error);
} finally {
setLoading(false);
}
};
fetchData();
}, []);
if (loading) return <LoadingSpinner />;
const formatearFecha = (fecha) => {
if (!fecha) return "-";
const date = fecha.toDate ? fecha.toDate() : new Date(fecha);
return `El ${date.toLocaleDateString("es-AR")} a las ${date.toLocaleTimeString("es-AR", {
hour: "2-digit",
minute: "2-digit",
hour12: false,
})}`;
};
return (
<div className="Trazabilidad">
<header className="trazabilidad-header">
<div className="header-content">
<h1>Inventario</h1>
</div>
</header>
{inventario.length === 0 ? (
<EmptyState label="inventario" />
) : (
<div className="trazabilidad-content">

<div className="section">
    <h2>Recientes</h2>
    {recientes.length === 0 ? (
        <p>No hay documentos recientes en el inventario.</p>
    ) : (
        <div className="recent-grid">
            {recientes.map((doc) => (
                <div
                    key={doc.id}
                    className="document-card recent-card"
                    // Aquí agregamos la función onClick
                    onClick={() => handleRowClick(doc.id)} 
                    style={{
                        flexDirection: "column",
                        textAlign: "left",
                        alignItems: "start",
                        justifyContent: "start",
                        gap: "2px",
                        // También puedes agregar un cursor para indicar que es clicable
                        cursor: 'pointer' 
                    }}
                >
                    <span className="doc-id" style={{ margin: 0 }}>
                        {doc.modificador || "Sin modificador"}
                    </span>
                    <p className="card-date" style={{ margin: 0 }}>
                        {formatearFecha(doc.fecha)}
                    </p>
                </div>
            ))}
        </div>
    )}
</div>

<div className="section">
{inventario.length === 0 ? (
<p>No hay documentos de inventario para mostrar.</p>
) : (
<div className="table-container">
<table className="table-full">
<thead>
<tr>
<th style={{ fontFamily: 'Effra', fontWeight: '600', cursor: 'default' }}>Modificado por</th>
<th style={{ fontFamily: 'Effra', fontWeight: '600', cursor: 'default' }}>Fecha de modificación</th>
<th style={{ fontFamily: 'Effra', fontWeight: '600', cursor: 'default' }}>Documento</th>
</tr>
</thead>
<tbody>
{inventario.map((doc) => (
<tr style={{cursor:'pointer'}} key={doc.id} onClick={() => handleRowClick(doc.id)} className="table-row">
<td style={{textAlign:'left'}}>{doc.modificador || "-"}</td>
<td>{formatearFecha(doc.fecha)}</td>
<td style={{overflow:'auto'}}>
<FileIcon style={{ height: "20px",width: "20px", margin: "auto", overflow:'visible' }} />
</td>
</tr>
))}
</tbody>
</table>
</div>
)}
</div>
</div>
)}
</div>
);
};
export default Inventario;